module.exports = __webpack_public_path__ + "media/assets/images/blog/Depositphotos_174354892_S-50cc7dce5fad20864cdc9a866b4aeb21.jpg";